import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  holidays: [],
  selectedHoliday: null,
};

const holidaySlice = createSlice({
  name: "companyHoliday",
  initialState,
  reducers: {
    // Get Holidays
    getHolidaysStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getHolidaysSuccess: (state, action) => {
      state.loading = false;
      state.holidays = action.payload;
      state.error = null;
    },
    getHolidaysFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Holiday
    createHolidayStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createHolidaySuccess: (state, action) => {
      state.loading = false;
      state.holidays.push(action.payload);
      state.error = null;
    },
    createHolidayFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Holiday
    updateHolidayStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateHolidaySuccess: (state, action) => {
      state.loading = false;
      const index = state.holidays.findIndex(
        (holiday) => holiday.id === action.payload.id,
      );
      if (index !== -1) {
        state.holidays[index] = action.payload;
      }
      state.error = null;
    },
    updateHolidayFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete Holiday
    deleteHolidayStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteHolidaySuccess: (state, action) => {
      state.loading = false;
      state.holidays = state.holidays.filter(
        (holiday) => holiday.id !== action.payload,
      );
      state.error = null;
    },
    deleteHolidayFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Holiday
    setSelectedHoliday: (state, action) => {
      state.selectedHoliday = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getHolidaysStart,
  getHolidaysSuccess,
  getHolidaysFailure,
  createHolidayStart,
  createHolidaySuccess,
  createHolidayFailure,
  updateHolidayStart,
  updateHolidaySuccess,
  updateHolidayFailure,
  deleteHolidayStart,
  deleteHolidaySuccess,
  deleteHolidayFailure,
  setSelectedHoliday,
  clearError,
} = holidaySlice.actions;

export default holidaySlice.reducer;
